import gql from "graphql-tag"

export default gql`
  query movieUpgradeTarget($id: String!) {
    movie: movieGet(id: $id) {
      id
      Media {
        id
      }
    }
  }
`
